import { Monitor, Smartphone, Search, Settings, Shield, Zap } from 'lucide-react';
import reference1 from "../assets/images/reference1.png";
import reference2 from "../assets/images/reference2.png";
import reference3 from "../assets/images/reference3.png";
import reference4 from "../assets/images/reference4.png";
import reference5 from "../assets/images/reference5.png";
import reference6 from "../assets/images/reference6.png";



export const mockData = {
services: [
  {
    title: "Site WordPress avec Elementor",
    description: "Création de sites WordPress flexibles et évolutifs avec Elementor, pour une gestion simple et autonome.",
    path: "/creation-site-wordpress",
    icon: <Monitor className="w-8 h-8 text-orange-500" />,
    features: [
      "WordPress + Elementor",
      "Design moderne et personnalisable",
      "Édition facile des contenus",
      "Responsive mobile & tablette",
      "Formulaire de contact",
      "Optimisation SEO de base"
    ]
  },
  {
    title: "Site WordPress optimisé",
    description: "Sites WordPress performants sans builder lourd, axés vitesse, stabilité et référencement.",
    path: "/creation-site-wordpress",
    icon: <Zap className="w-8 h-8 text-orange-500" />,
    features: [
      "WordPress sans Elementor",
      "Chargement rapide",
      "Structure SEO optimisée",
      "Code léger et propre",
      "Sécurité renforcée",
      "Maintenance simplifiée"
    ]
  },
  {
    title: "Site Web sur-mesure",
    description: "Conception de sites personnalisés, développés selon vos besoins spécifiques et votre identité.",
    path: "/creation-site-vitrine",
    icon: <Settings className="w-8 h-8 text-orange-500" />,
    features: [
      "Design 100 % personnalisé",
      "Fonctionnalités spécifiques",
      "Performance élevée",
      "Évolutivité totale",
      "Aucune dépendance inutile",
      "Contrôle complet du projet"
    ]
  },
  {
    title: "Référencement naturel (SEO)",
    description: "Optimisation SEO pour améliorer votre visibilité et attirer un trafic qualifié.",
    path: "/referencement-seo",
    icon: <Search className="w-8 h-8 text-orange-500" />,
    features: [
      "Optimisation technique",
      "Structure SEO",
      "Mots-clés ciblés",
      "SEO local",
      "Amélioration du positionnement",
      "Bonnes pratiques Google"
    ]
  },
  {
    title: "Maintenance & Sécurité",
    description: "Suivi technique, mises à jour et protection continue de votre site.",
    path: "/maintenance-wordpress",
    icon: <Shield className="w-8 h-8 text-orange-500" />,
    features: [
      "Mises à jour régulières",
      "Sauvegardes automatiques",
      "Surveillance de sécurité",
      "Support technique",
      "Interventions rapides",
      "Tranquillité d’esprit"
    ]
  }
],


  processSteps: [
    {
      title: "Brief & Analyse",
      description: "Nous analysons vos besoins, votre secteur d'activité et vos objectifs pour définir la meilleure stratégie.",
      duration: " "
    },
    {
      title: "Maquette & Design",
      description: "Création de maquettes personnalisées qui reflètent votre identité et séduisent vos clients.",
      duration: "optionnel"
    },
    {
      title: "Développement",
      description: "Intégration du design et développement des fonctionnalités avec les dernières technologies.",
      duration: ""
    },
    {
      title: "Mise en Ligne",
      description: "Tests, optimisations et mise en ligne de votre site avec formation à la gestion.",
      duration: ""
    }
  ],

  portfolioItems: [
    {
      title: "France valley",
      slug: "france-valley",
      description: "L’expertise financière au service de la nature.",
      technologies: ["SEO", "Webdesign", "SEA"],
      image: reference1,
      challenge: "Clarifier une offre financière exigeante et la rendre plus accessible sans perdre le niveau de confiance attendu.",
      solution: "Structurer les messages clés, hiérarchiser les contenus et guider les visiteurs vers les informations essentielles.",
      result: "Une vitrine plus professionnelle, plus claire et mieux adaptée à une audience en recherche de sérieux."
    },
    {
      title: "Barreshape",
      slug: "barreshape",
      description: "Barreshape : cours de barre au sol Paris.",
      technologies: ["SEO", "Webdesign"],
      image: reference2,
      challenge: "Présenter une activité sportive avec une image premium, simple à comprendre et orientée réservation.",
      solution: "Mettre en avant l’univers visuel, les cours, la promesse et les informations pratiques pour faciliter la prise de contact.",
      result: "Un site vitrine plus immersif, cohérent avec la marque et plus efficace pour convertir les visiteurs intéressés."
    },
    {
      title: "Monceau langues",
      slug: "monceau-langues",
      description: "La référence des formations linguistiques pour les professionnels.",
      technologies: ["WordPress", "Webdesign"],
      image: reference3,
      challenge: "Valoriser une offre de formations linguistiques B2B et rendre les parcours plus faciles à parcourir.",
      solution: "Organiser les contenus, clarifier les messages et adapter l’interface à une cible professionnelle.",
      result: "Une présentation plus structurée des formations et une meilleure lisibilité pour les entreprises."
    },
    {
      title: "Cabinet Belloy",
      slug: "cabinet-belloy",
      description: "Site vitrine moderne pour présenter le cabinet de l'avocat à la cour Maître Belloy.",
      technologies: ["WordPress", "Webdesign"],
      image: reference5,
      challenge: "Présenter une activité juridique avec sobriété, crédibilité et lisibilité.",
      solution: "Créer une vitrine élégante, structurée autour des informations essentielles du cabinet et d’une navigation directe.",
      result: "Un site professionnel qui rassure les visiteurs et met en valeur l’expertise du cabinet."
    },
    {
      title: "La Tortue",
      slug: "la-tortue",
      description: "Expert en robots de tonte : Audit, Conseil, Vente, Location, Installation, Réparation / Entretien de robots tondeuses multimarques.",
      technologies:["SEO", "Webdesign" , "SEA" , "SMA"],
      image: reference4,
      challenge: "Présenter une activité technique et commerciale autour des robots de tonte avec un discours clair.",
      solution: "Mettre en avant les services, l’expertise multimarque et les cas d’usage pour aider le visiteur à comprendre l’offre.",
      result: "Une vitrine plus explicite, capable d’accompagner la découverte et la demande de conseil."
    },
    {
      title: "Money Date",
      slug: "money-date",
      description: "Vous accompagner pour comprendre vos droits et protéger votre avenir, votre patrimoine et les personnes qui comptent pour vous.",
      technologies: ["WordPress", "Webdesign"],
      image: reference6,
      challenge: "Rendre un sujet sensible plus accessible avec un ton rassurant et une expérience de lecture claire.",
      solution: "Construire un design éditorial, hiérarchiser les contenus et mettre en avant les messages de confiance.",
      result: "Un site plus humain, plus lisible et mieux adapté à une audience qui cherche à comprendre avant de passer à l’action."
    }
  ],

  testimonials: [
    {
      name: "Marie Durand",
      business: "Restaurant Le Petit Bordeaux",
      review: "Excellent travail ! Notre site vitrine a doublé nos réservations en 3 mois. L'équipe est très professionnelle et à l'écoute."
    },
    {
      name: "Pierre Martin",
      business: "Plomberie Martin & Fils", 
      review: "Site parfait pour notre activité. Design moderne, facile à utiliser et nous recevons beaucoup plus d'appels depuis sa mise en ligne."
    },
    {
      name: "Sophie Leclerc",
      business: "Coiffure Élégance",
      review: "Je recommande vivement ! Site magnifique qui correspond parfaitement à l'image de mon salon. Mes clientes adorent."
    },
    {
      name: "Jean-Luc Moreau",
      business: "Menuiserie Moreau",
      review: "Très satisfait du résultat. Site professionnel qui met en valeur notre savoir-faire. Le référencement local fonctionne très bien."
    }
  ],

  pricingPlans: [
    {
      name: "Site Vitrine Basique",
      description: "Parfait pour débuter votre présence en ligne",
      originalPrice: 600,
      launchPrice: 450,
      features: [
        "Jusqu'à 5 pages",
        "Design responsive", 
        "Formulaire de contact",
        "Optimisation mobile",
        "Hébergement 1 an inclus"
      ]
    },
    {
      name: "Site Vitrine Avancé", 
      description: "Solution complète pour votre activité",
      originalPrice: 900,
      launchPrice: 675,
      features: [
        "Jusqu'à 10 pages",
        "Design sur-mesure",
        "SEO optimisé",
        "Galerie photos",
        "Google Maps",
        "Réseaux sociaux",
        "Formation incluse"
      ]
    },
    {
      name: "Pack E-commerce Simple",
      description: "Boutique en ligne clé en main",
      originalPrice: 1200,
      launchPrice: 900,
      features: [
        "Jusqu'à 50 produits",
        "Paiement en ligne sécurisé",
        "Gestion des stocks",
        "Tableau de bord",
        "Formation e-commerce",
        "Support prioritaire"
      ]
    }
  ],

  additionalOptions: [
    {
      name: "Création Logo",
      description: "Logo professionnel et charte graphique",
      price: "150 €"
    },
    {
      name: "Rédaction",
      description: "Contenu optimisé SEO",
      price: "50 €/page"
    },
    {
      name: "SEO Avancé",
      description: "Optimisation complète",
      price: "200 €"
    },
    {
      name: "Maintenance",
      description: "Support mensuel",
      price: "30 €/mois"
    }
  ],

  faqItems: [
    {
      question: "Quel est le délai de création d'un site ?",
      answer: "En moyenne, un site vitrine basique prend 10-15 jours ouvrés, un site avancé quelques semaines. Le délai peut varier selon la complexité et la rapidité de fourniture des contenus."
    },
    {
      question: "Que dois-je fournir pour la création de mon site ?",
      answer: "Vos textes, photos de qualité, logo (si existant), coordonnées complètes et toute information spécifique à votre activité. Nous pouvons vous accompagner dans la rédaction si besoin."
    },
    {
      question: "Le site sera-t-il visible sur mobile ?",
      answer: "Absolument ! Tous nos sites sont responsive design, c'est-à-dire qu'ils s'adaptent automatiquement à tous les écrans (smartphone, tablette, ordinateur)."
    },
    {
      question: "Proposez-vous la maintenance après livraison ?",
      answer: "Oui, nous proposons des contrats de maintenance incluant mises à jour, sauvegardes et support technique."
    },
    {
      question: "Le référencement SEO est-il inclus ?",
      answer: "L'optimisation SEO de base est incluse dans tous nos sites (balises, structure, vitesse). Pour un SEO avancé avec suivi de positionnement, un devis vous sera proposé."
    },
    {
      question: "Puis-je modifier mon site après livraison ?",
      answer: "Oui ! S'il s'agit d'un site wordpress, nous pouvons vous former à la gestion de votre site. Vous pourrez modifier textes, images et actualités en autonomie."
    }
  ]
};
